var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resultBar "},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../assets/image/line.jpg"),"alt":""}}),_c('div',{staticClass:"resultSlotBox"},[_vm._t("resultRight")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }